import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import { Block, BlockHeader } from '../../styles/defaults'
import { StyledLink } from './styles'

import Notice from '../Notice/'
import Appointment from '../Appointment/'
import Message from '../Message/'

class Module extends Component {
  render() {
    const { title, notices, appointments, messages } = this.props

    if (notices) {
      while (notices.length < 3) {
        notices.push({
          empty: true
        })
      }
    }

    if (appointments) {
      while (appointments.length < 3) {
        appointments.push({
          empty: true
        })
      }
    }

    return (
      <Block two={this.props.full}>
        <BlockHeader>
          <h2>{title}</h2>
          {appointments && (
            <StyledLink>
              <Link to="/agenda">Bekijk agenda</Link>
            </StyledLink>
          )}
        </BlockHeader>

        {notices &&
          notices.map((notice, index) => {
            return <Notice key={index} notice={notice} />
          })}

        {messages && messages.map((message, index) => {
          return <Message key={index} message={message} />
        })}

        {appointments &&
          appointments.map((appointment, index) => {
            if (appointment.empty) {
              return (
                <Appointment key={index} appointment={appointment} dashboard />
              )
            }
            return (
              <Link to="/agenda" key={index}>
                <Appointment appointment={appointment} dashboard />
              </Link>
            )
          })}
      </Block>
    )
  }
}

export default Module



// WEBPACK FOOTER //
// ./src/components/Module/index.js